import IronsRecommendation from './IronsRecommendation';

export default IronsRecommendation;
